import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    if (this.tabTargets.length > 0) {
      this.selectTab(this.tabTargets[0])
    }
  }

  select(event) {
    event.preventDefault()
    this.selectTab(event.currentTarget)
  }

  selectTab(tab) {
    const index = tab.dataset.index

    this.tabTargets.forEach((el) => {
      const isActive = el === tab
      el.classList.toggle("bg-ph24_blue", isActive)
      el.classList.toggle("text-white", isActive)
      el.classList.toggle("shadow-md", isActive)
      el.classList.toggle("border-ph24_blue_secondary", isActive)
      el.classList.toggle("bg-white", !isActive)
      el.classList.toggle("text-ph24_blue", !isActive)
      el.classList.toggle("hover:bg-gray-50", !isActive)
      el.classList.toggle("border-transparent", !isActive)
    })

    this.panelTargets.forEach((el) => {
      el.classList.toggle("hidden", el.dataset.index !== index)
    })
  }
}
